import CRUD from './genericCRUD'

const route = 'farms'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function farms(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {string} name
		 * @param {number} countryId
		 * @param {string} location
		 * @param {number} regionId
		 * @param {string} licensorId
		 * @param {string} licenseHolderId
		 * @param {string} subLicenseHolderId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (
			pageNumber,
			pageSize,
			name,
			regionId,
			location,
			countryId,
			licensorId,
			licenseHolderId,
			subLicenseHolderId,
			config = {}
		) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const nameParam = name ? `name=${name}&` : ''
			const regionParam = regionId ? `regionId=${regionId}&` : ''
			const locationParam = location ? `location=${location}&` : ''
			const countryParam = countryId ? `countryId=${countryId}&` : ''
			const licensorParam = licensorId ? `licensorId=${licensorId}&` : ''
			const licenseHolderParam = licenseHolderId ? `licenseHolderId=${licenseHolderId}&` : ''
			const subLicenseHolderParam = subLicenseHolderId ? `subLicenseHolderId=${subLicenseHolderId}&` : ''

			return instance.get(
				`${route}?${params}${nameParam}${regionParam}${locationParam}${countryParam}${licensorParam}${licenseHolderParam}${subLicenseHolderParam}`,
				config
			)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		update: (body, config = {}) => {
			return instance.put(`${route}`, body, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getFarmPhases: (id, config = {}) => {
			return instance.get(`${route}/${id}/phases`, config)
		},

		/**
		 * @param {{ farmIds: array }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getFarmVarieties: (body, config = {}) => {
			return instance.post(`${route}/varieties`, body, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getFarmsAndNurseries: (config = {}) => {
			return instance.get(`${route}/nurseries`, config)
		}
	}
}
